import { Button } from "@mui/material";
import { styled } from "@mui/material/styles";
import { maxWidthWaitingList } from "../../../theme/styles";
import { colors } from "../../../theme/colors";

const borderRadius = "100px";

const InputContainer = styled("div")(({ theme }) => ({
  display: "flex",
  maxWidth: maxWidthWaitingList,
  alignItems: "center",
  borderRadius,
  width: "100%",
  height: "100%",
  marginTop: "12px",
  position: "relative",
}));

const StyledInput = styled("input")(({ theme }) => ({
  border: "none",
  flex: 1,
  padding: "12px",
  borderRadius,
  height: "100%",
  width: "100%",
  boxSizing: "border-box",
}));

const StyledButton = styled(Button)(({ theme }) => ({
  position: "absolute",
  right: "0",
  top: "0",
  borderRadius,
  height: "100%",
  width: "auto",
  backgroundColor: "#5864ec", // Cor de fundo do botão
  color: "#fff", // Cor do texto do botão
  "&:hover": {
    backgroundColor: "#4a54e1", // Cor de fundo ao passar o mouse
    border: `2px solid ${colors.background.error}`
  },
  border: "2px solid white",
}));

export const InputWaitingList = () => {
  return (
    <InputContainer>
      <StyledInput placeholder="Digite seu e-mail" />
      <StyledButton
        variant="contained"
        style={{ backgroundColor: colors.background.error }}
      >
        Enviar
      </StyledButton>
    </InputContainer>
  );
};
